module.exports = __webpack_public_path__ + "img/daftar_pick_up.61411230.svg";